import flow from 'lodash/fp/flow'
import map from 'lodash/fp/map'
import uniq from 'lodash/fp/uniq'

export function getCourseDate(
  firstDate: string,
  secondDate: string | null | undefined
) {
  if (!secondDate || firstDate === secondDate)
    return formatDate(firstDate, 'DD.MM.YYYY')

  const [startDate, endDate] = flow(
    map<string, string>(dateString => formatDate(dateString, 'DD.MM.YYYY')),
    uniq
  )([firstDate, secondDate])

  return `${startDate} - ${endDate}`
}
